import * as dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { startCase } from "lodash";
dayjs.extend(isBetween);
dayjs.extend(utc);
dayjs.extend(timezone);

export default {
  prettyDate: function (date, format) {
    if (typeof format == "undefined") {
      format = "ddd, MMM D YYYY, h:mm A";
    }
    let myDate = dayjs(date).format(format);
    return myDate;
  },
  dateIsBetween(startDate, endDate, targetDate) {
    return dayjs(targetDate).isBetween(startDate, endDate, "day", "[]");
  },
  extract: function ([beg, end]) {
    const matcher = new RegExp(`${beg}(.*?)${end}`, "gm");
    const normalise = (str) => str.slice(beg.length, end.length * -1);
    return function (str) {
      return str.match(matcher).map(normalise);
    };
  },
  textToUpperCase: function (status) {
    return status ? startCase(status) : "N/A";
  },
  convertUTCToLocal: function (dateTime) {
    return dayjs(dateTime)
      .add(-1 * dayjs(dateTime).utcOffset(), "minute")
      .format();
  },
  convertToTorontoUTC: function (dateTime) {
    const canadaOffset = dayjs
      .tz(new Date(dateTime), "America/Toronto")
      .utcOffset();
    return dayjs(dateTime)
      .add(dayjs(dateTime).utcOffset(), "minute")
      .add(canadaOffset, "minute")
      .utc()
      .format();
  },
  getFileTypeByExtension: function (extension) {
    if (extension == "xls" || extension == "xlsx") {
      return "excel";
    } else if (extension == "ppt" || extension == "pptx") {
      return "powerpoint";
    } else if (extension == "doc" || extension == "docx") {
      return "word";
    } else if (extension == "pdf") {
      return "pdf";
    } else if (["jpg", "jpeg", "png", "gif"].includes(extension)) {
      return "image";
    }
    return null;
  },
  sortAlphabetically: function (arr) {
    return [...arr].sort((a, b) => (a.name || "").localeCompare(b.name || ""));
  },
  formatMaxDecimals: function (value, digits = 2) {
    if (value === null || value === undefined) return "";
    const num = Number(value);
    if (Number.isNaN(num)) return "";
    const factor = Math.pow(10, digits);
    const rounded = Math.round((num + Number.EPSILON) * factor) / factor;
    let str = rounded.toString();
    if (str.indexOf(".") === -1) return str;
    str = str.replace(/0+$/g, "").replace(/\.$/, "");
    return str;
  },
  formatMoney: function (value) {
    return `${+parseFloat(value || 0).toFixed(2)}`.replace(
      /(\d)(?=(\d{3})+(?!\d))/g,
      "$1,"
    );
  },
  escapeHtml: function (str) {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#x27;");
  },
};
